import { Link } from "gatsby";
import React, { useRef, useState } from "react";
import Formsy from "formsy-react";
import TextField from "../bootstrap/input";
import Captcha from "../bootstrap/captcha2";
import { Button } from "react-bootstrap";
import { navigate } from "gatsby";

export default function ChangePassword() {
  const params = new URLSearchParams(location.search);
  const verificationCode = params.get("v");
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [canSubmit, setCanSubmit] = useState(false);
  const [captchaRefreshKey, setRefreshKey] = useState(new Date());
  const [errorMessage, setErrorMessage] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (data) => {
    setLoading(true);
    
    try {
      const response = await fetch(`${process.env.BACKEND_URL}rest.api/change-password`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          captcha: data.captcha,
          captchaKey: data.captchaKey,
          verificationCode: verificationCode,
          password: data.password
        }),
      });

      switch (response.status) {
        case 400:
        case 401:
        case 503:
          setRefreshKey(new Date());
          const result = await response.json();
          setErrorMessage(result.error || "An error has occurred");
          setIsSuccess(false);
          break;
        case 200:
          setIsSuccess(true)
          setErrorMessage(null);
      }

      return setLoading(false);
    } catch (err) {
      setErrorMessage("An error has occurred");
      return setLoading(false);
    }
  }

  const handleDisable = () => setCanSubmit(false);
  const handleEnable = () => setCanSubmit(true);

  return (
    <div className="forgot_change-password">
      <section className="main">
        {isSuccess ? <ChangeSuccessful/> :
        <div className="form-container">
          <h3>Change Password</h3>
          <p>Please provide a new password.</p>
          <Formsy
            ref={formRef}
            onValidSubmit={handleSubmit}
            onInvalid={handleDisable}
            onValid={handleEnable}
            onChange={() => setErrorMessage(null)}
          >
            <div className="form-field">
              <TextField
                name="password"
                label="New Password"
                autoComplete="off"
                placeholder="New Password"
                disabled={loading}
                required
                type="password"
              />
            </div>
            <div className="form-field">
              <TextField
                name="confirm_password"
                label="Confirm Password"
                autoComplete="off"
                placeholder="Confirm Password"
                disabled={loading}
                required
                type="password"
                validations={{
                  isMatch: (values, val) => {
                    if (values.password !== val) {
                      return "Passwords do not match."
                    }
  
                    return true
                  }
                }}
              />
            </div>
            <div className="form-field">
              <Captcha name="captcha" refreshKey={captchaRefreshKey} />
            </div>
            {errorMessage && <div className="error-div">{errorMessage}</div>}
            <div className="actions-container">
              <Button
                variant="secondary"
                disabled={loading}
                onClick={() => navigate("/")}
              >
                {"Cancel"}
              </Button>
              <Button
                className="submit"
                type="submit"
                disabled={loading || !canSubmit}
              >
                {"Submit"}
              </Button>
            </div>
          </Formsy>
        </div>}
      </section>
    </div>
  )
}

function ChangeSuccessful() {
  return (
    <div className="forgot-change-success">
      <h3>Password Updated</h3>
      <p className="vw-brand-description">
        Your password has been updated successfully!
      </p>
      <Button
        onClick={() => navigate("/")}
      >
        Return to Login
      </Button>
    </div>
  )
}